import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';

import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, {FormBody, FormActions, TextInput, SelectInput, DateInput} from '../../../Form';
import moment from "moment";

@inject('hydrologyStore')
@observer
class TableEdit extends Component {
  // static propTypes = {
    // route: PropTypes.shape().isRequired,
    // params: PropTypes.shape({
      // id: PropTypes.string.isRequired,
    // }).isRequired,
    // metaDataStore: PropTypes.object.isRequired,
  // };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  slug = 'hydrology/rt_method/table_list';
  title = 'Edit Listing';
  disposer = null;

  @observable item = {
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    table_no: '',
  };

  constructor(props) {
    super(props);
    this.reset();
  }

  componentWillMount() {
    if(this.props.hydrologyStore.selectedStation === '')
      this.context.router.push(this.slug);

    this.props.hydrologyStore.fetchStations();
    this.props.hydrologyStore.fetchUniqueTypeNumbersByStationIndex();

    this.reset();
  }

  @action reset() {
    const { params: { id }, hydrologyStore } = this.props;
    const foundRatingTable = hydrologyStore.findRatingTableById(id);
    if (foundRatingTable) {
      this.item = {
        start_date: moment(foundRatingTable.start_date).format('YYYY-MM-DD'),
        end_date: moment(foundRatingTable.end_date).format('YYYY-MM-DD'),
        table_no: `${foundRatingTable.rating_type_no}`,
        serial_no: foundRatingTable.serial_no,
        rating_curve_id: foundRatingTable.rating_curve_id,
        id: foundRatingTable.id
      };
    }
  }

  @action onTypeNoChange = (e) => { this.item.table_no = e.target.value; }

  @action onStartDateChange = (e) => {
    this.item.start_date =  e.target.value;
  };

  @action onEndDateChange = (e) => {
    this.item.end_date =  e.target.value;
  };

  handleSave = (e) => {
    e.preventDefault();

    const { hydrologyStore } = this.props;
    const {table_no, start_date, end_date, rating_curve_id, id} = this.item;

    const payload = {
      start_date: new Date(start_date).toISOString(),
      end_date: new Date(end_date).toISOString(),
      station_index: hydrologyStore.selectedStation,
      rating_curve_id,
      id
    };

    if (table_no !== "" && table_no !== hydrologyStore.selectedTypeNo) {
      payload.table_no = table_no;
    }

    hydrologyStore.updateRatingTable(payload)
      .then((res) => {
        if(!res.error)
          this.context.router.push(this.slug);
      });
  }

  render() {
    const { hydrologyStore, params: { id } } = this.props;

    const { selectedStation, associatedTSSStation, typeNumbers } = hydrologyStore;

    if (hydrologyStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={hydrologyStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput readOnly={true} label={"Station Index"} value={selectedStation}/>
            {associatedTSSStation && <TextInput readOnly={true} label={"Station Name"} value={associatedTSSStation.name}/>}
            <TextInput readOnly={true} label={"Serial No"} value={this.item.serial_no}/>
            <SelectInput options={[{rating_type_no: 'New'}, ...typeNumbers.map(item => ({rating_type_no: `${item.rating_type_no}`}))]}
                         label={"Table No"}
                         fields={{label: 'rating_type_no', value: 'rating_type_no'}}
                         onChange={this.onTypeNoChange}
                         value={this.item.table_no}/>
            <DateInput value={this.item.start_date}
                       onChange={this.onStartDateChange}
                       label={'Start Date'}/>
            <DateInput value={this.item.end_date}
                       onChange={this.onEndDateChange}
                       label={'End Date'}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default TableEdit;



// WEBPACK FOOTER //
// ./src/components/Hydrology/RT Method/Table/TableEdit.js